var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Configuración Base" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("SeleccionarCodigosForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.seleccionarCodigos.step,
                expression: "pasoActivoIndex === pasos.seleccionarCodigos.step"
              }
            ],
            attrs: {
              alertaBaseSeleccionada: _vm.alertaBaseSeleccionada,
              modoVer: true
            }
          }),
          _vm.pasoActivoIndex === _vm.pasos.agregarCampos.step
            ? _c("AgregarCamposGrid", {
                attrs: {
                  camposDinamicos:
                    _vm.alertaBaseSeleccionada &&
                    _vm.alertaBaseSeleccionada.alertaCampoDinamico,
                  modoVer: true
                }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.scriptValidacionExtendida.step
            ? _c("ValidacionExtendidaForm", {
                attrs: {
                  scriptActividadExt:
                    _vm.alertaBaseSeleccionada &&
                    _vm.alertaBaseSeleccionada.scriptActividadExt,
                  modoVer: true
                }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.htmlTemplateAccion.step
            ? _c("HtmlTemplateForm", {
                attrs: {
                  htmlTemplate:
                    _vm.alertaBaseSeleccionada &&
                    _vm.alertaBaseSeleccionada.htmlBody,
                  mensaje:
                    _vm.alertaBaseSeleccionada &&
                    _vm.alertaBaseSeleccionada.mensaje,
                  modoVer: true
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }